export const GALLERY_IMAGE_SIZE = { width: 280, height: 200 };
export const GALLERY_IMAGE_SIZE_MOBILE = { width: 220, height: 160 };

export enum DataHooks {
  Root = 'service-details-dialog',
  Image = 'service-details-dialog-image',
  Gallery = 'service-details-dialog-gallery',
  GalleryImage = 'service-details-dialog-gallery-image',
  OnlineBadge = 'service-details-dialog-online-badge',
  Title = 'service-details-dialog-title',
  TagLine = 'service-details-dialog-tagline',
  DetailsList = 'service-details-dialog-details',
  Duration = 'service-details-dialog-duration',
  Price = 'service-details-dialog-price',
  PriceAfterDiscount = 'service-details-dialog-price-after-discount',
  PriceBeforeDiscount = 'service-details-dialog-price-before-discount',
  DiscountName = 'service-details-dialog-discount-name',
  CalculatedAtCheckout = 'service-details-dialog-calculated-at-checkout',
  Location = 'service-details-dialog-location',
  DescriptionTitle = 'service-details-dialog-description-title',
  Description = 'service-details-dialog-description',
  PolicySection = 'service-details-dialog-policy-section',
  PolicyTitle = 'service-details-dialog-policy-title',
  Policy = 'service-details-dialog-policy',
  ContactSection = 'service-details-dialog-contact-section',
  ContactTitle = 'service-details-dialog-contact-title',
  ContactLocation = 'service-details-dialog-contact-location',
  ContactAddress = 'service-details-dialog-contact-address',
  ContactPhone = 'service-details-dialog-contact-phone',
  ContactEmail = 'service-details-dialog-contact-email',
}
